import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPen3Icon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="#000"
      d="M4.168 15h3.533a.83.83 0 0 0 .592-.242l5.767-5.775 2.366-2.316a.833.833 0 0 0 0-1.184l-3.533-3.575a.834.834 0 0 0-1.183 0L9.36 4.267l-5.784 5.775a.83.83 0 0 0-.241.591v3.534a.833.833 0 0 0 .833.833m8.133-11.325 2.359 2.358-1.184 1.184-2.358-2.359zm-7.3 7.3 4.942-4.942 2.358 2.359-4.941 4.941H5zm12.5 5.692h-15a.833.833 0 1 0 0 1.666h15a.833.833 0 0 0 0-1.666M16.75 12.229a.85.85 0 0 1-.102.427.85.85 0 0 1-.278.296 1.2 1.2 0 0 1-.391.168v.015q.43.053.652.263.224.21.224.562 0 .313-.153.559a1 1 0 0 1-.47.388q-.316.142-.817.142-.295 0-.552-.049a2.2 2.2 0 0 1-.478-.144v-.642a2.2 2.2 0 0 0 .95.237q.404 0 .566-.14a.5.5 0 0 0 .163-.395q0-.15-.075-.251a.48.48 0 0 0-.264-.157 2 2 0 0 0-.52-.053h-.27v-.579h.275q.33 0 .5-.061.174-.064.235-.171a.5.5 0 0 0 .063-.249.38.38 0 0 0-.117-.298q-.117-.107-.39-.107a1 1 0 0 0-.313.044 1.3 1.3 0 0 0-.252.102q-.111.06-.197.115l-.35-.52q.21-.152.491-.252.284-.1.674-.1.552 0 .874.223a.72.72 0 0 1 .322.627"
    />
  </svg>
);
export default SvgPen3Icon;
